import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const useWarehouseStore = create(
  persist(
    (set) => ({
      currentWarehouse: null,
      isUpdated: false,

      setCurrentWarehouse: (currentWarehouse, isUpdated = false) =>
        set({
          currentWarehouse,
          isUpdated,
        }),

      clearCurrentWarehouse: () =>
        set({
          currentWarehouse: null,
          isUpdated: false,
        }),

      syncCurrentWarehouseFromUser: (warehouse) => {
        if (!warehouse) {
          set({
            currentWarehouse: null,
            isUpdated: false,
          });
          return;
        }

        set({
          currentWarehouse: warehouse.currentWarehouse,
          isUpdated: warehouse.isUpdated,
        });
      },
    }),
    {
      name: "current-warehouse-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        currentWarehouse: state.currentWarehouse,
        isUpdated: state.isUpdated,
      }),
    },
  ),
);

export default useWarehouseStore;
